// Typelizer digest 4513fdbdeb475f6ab420d9c2546d63ce
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /api/projects/manage */
  manage: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/api/projects/manage', {}, options),
    method: 'get',
  }),

  /** POST /api/projects/:id/toggle_project_blocked */
  toggleProjectBlocked: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/api/projects/:id/toggle_project_blocked', params, options),
    method: 'post',
  }),

  /** DELETE /api/projects/:id/purge_attachment */
  purgeAttachment: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/api/projects/:id/purge_attachment', params, options),
    method: 'delete',
  }),

  /** GET /api/projects */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/api/projects', {}, options),
    method: 'get',
  }),

  /** POST /api/projects */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/api/projects', {}, options),
    method: 'post',
  }),

  /** GET /api/projects/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/api/projects/:id', params, options),
    method: 'get',
  }),

  /** PATCH /api/projects/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/api/projects/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /api/projects/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/api/projects/:id', params, options),
    method: 'delete',
  }),
}
